import { StatsTableRow } from './stats-table-row';

export { StatsTableRow };
